import { Button } from '@chakra-ui/react'
import { LiveOutputDetail } from '@features/liveOutputs/components/LiveOutputDetail'
import { createFileRoute, getRouteApi, Link } from '@tanstack/react-router'
import { FaArrowLeft } from 'react-icons/fa6'
import { Route as liveOutputListRoute } from '@routes/_auth/o/$orgId/liveOutputs'

const routeApi = getRouteApi('/_auth/o/$orgId/liveOutputs/$liveOutputId')

const BackButton = () => {
  const { orgId } = routeApi.useParams()
  return (
    <Link to={liveOutputListRoute.to} params={{ orgId }}>
      <Button leftIcon={<FaArrowLeft />} size="xs">
        Back to List
      </Button>
    </Link>
  )
}

const LiveOutputDetailRoute = () => {
  const { liveOutputId } = routeApi.useParams()
  return (
    <>
      <BackButton />
      <LiveOutputDetail liveOutputId={liveOutputId} />
    </>
  )
}

export const Route = createFileRoute(
  '/_auth/o/$orgId/liveOutputs/$liveOutputId'
)({
  component: LiveOutputDetailRoute,
  beforeLoad: () => ({ getTitle: () => 'Live Output' }),
  loader: () => ({
    crumb: 'Output',
  }),
})
